export default __webpack_public_path__ + "static/media/About_scotland.dbe4c998.jpg";